module.exports = __webpack_public_path__ + "269ff3980487279f875c8f62df0b5918.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-ultralight.woff
// module id = 82
// module chunks = 0